import React from 'react';
import './App.css';
import Navigation from './sectionBlocks/Navigation';
import {Helmet} from "react-helmet";

function App() {
  return (
    <>
      <Helmet>
        <title>Pop Belly NFT</title>
        <meta name="description"
              content="Best NFT Pictures and Videos Of People BedRooms and Mancaves PopBeLLY NFT. Available to purchase on rarible and opensea!"/>
        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:site" content="@user"/>
        <meta name="twitter:creator" content="@user"/>
        <meta name="twitter:title" content="PICTURES-VIDEOS NFT PPL MANCAVES"/>
        <meta property="og:locale" content="en_US"/>
        <meta property="fb:app_id" content="ID_APP_FACEBOOK"/>
        <meta name="twitter:description" content="PICTURES-VIDEOS NFT PPL MANCAVES"/>
        <meta name="twitter:image" content="url_to_image"/>
        <meta property="og:title" content="POP BELLY NFT"/>
        <meta property="og:description"
              content="Best NFT Pictures and Videos Of People BedRooms and Mancaves PopBeLLY NFT. Available to purchase on rarible and opensea!"/>

      </Helmet>
      <Navigation/>
    </>
  );
}

export default App;
